/**
 * RelatedList — 관련 단지 내부링크 리스트 (목업 `.rel`).
 *
 * 순수 프레젠테이션. SEO 내부링크용. 각 항목은 react-router Link 로 내부 이동한다.
 * 썸네일 자리(bg-block, "이미지 준비중") + 제목/부제 + 우측 가격.
 */

import React from 'react';
import { Link } from 'react-router-dom';

export interface RelatedListItem {
  id: number | string;
  title: string;
  sub?: string;
  price?: string;
  href: string;
}

export interface RelatedListProps {
  items: RelatedListItem[];
  className?: string;
}

export function RelatedList({ items, className = '' }: RelatedListProps) {
  return (
    <div className={className}>
      {items.map((item) => (
        <Link
          key={item.id}
          to={item.href}
          className="flex items-center gap-[11px] border-t border-ca-line-soft py-2.5 no-underline first:border-t-0"
        >
          <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-ca-lg bg-block text-center text-[8.5px] font-bold leading-tight text-mute2">
            이미지
            <br />
            준비중
          </span>
          <div className="min-w-0">
            <div className="text-[13.5px] font-bold text-ink">{item.title}</div>
            {item.sub && <div className="mt-0.5 text-[11.5px] text-muted">{item.sub}</div>}
          </div>
          {item.price && (
            <span className="ml-auto whitespace-nowrap text-[12.5px] font-extrabold text-accent-dark">
              {item.price}
            </span>
          )}
        </Link>
      ))}
    </div>
  );
}

export default RelatedList;
